//------------- REACT IMPORT ---------------//
import React from "react";
//-------- BOOTSTRAP ITEMS IMPORT ---------//
import { Button, Col, Form, Modal, Row } from "react-bootstrap";

const AddMedicineModal = (props) => {
    return (
        <div>
            <Modal show={props.show} onHide={props.close} centered className="add_report_modal">
                <Modal.Header closeButton>
                    <Modal.Title>Add Medicine</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="add_medicine_form">
                        <Form>
                            <Row>
                                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                                    <Form.Group className="form-group">
                                        <Form.Label>Brand<span>*</span></Form.Label>
                                        <Form.Control type="text" placeholder="Ex. Blood Test" />
                                    </Form.Group>
                                </Col>
                                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                                    <Form.Group className="form-group">
                                        <Form.Label>Name<span>*</span></Form.Label>
                                        <Form.Control type="text" placeholder="NaCl" />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                                    <Form.Group className="form-group">
                                        <Form.Label>Salt</Form.Label>
                                        <Form.Control type="text" placeholder="Ex. Blood Test" />
                                    </Form.Group>
                                </Col>
                                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                                    <Form.Group className="form-group">
                                        <Form.Label>Dosage<span>*</span></Form.Label>
                                        <Form.Control type="text" placeholder="NaCl" />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                                    <Form.Group className="form-group">
                                        <Form.Label>Route<span>*</span></Form.Label>
                                        <Form.Control type="text" placeholder="Ex. 12 June, 2023" />
                                    </Form.Group>
                                </Col>
                                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                                    <Form.Group className="form-group">
                                        <Form.Label>Frequency<span>*</span></Form.Label>
                                        <Form.Control type="text" placeholder="Ex. 12 June, 2023" />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <div className="btn_area">
                                <Button className="cancelBtn" type="button" onClick={props.close} >
                                    Clear All
                                </Button>
                                <Button
                                    className="submitBtn"
                                    type="submit"
                                >
                                    Apply
                                </Button>
                            </div>
                        </Form>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default AddMedicineModal;